module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "document"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "document__title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "document__issuer"
  }, [_vm._v("\n                " + _vm._s(_vm.issuer) + "\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document__icon"
  }, [_c('span', {
    staticClass: "fa-stack fa-2x"
  }, [_c('i', {
    staticClass: "fas fa-circle fa-stack-2x"
  }), _vm._v(" "), _c('i', {
    staticClass: "fal fa-smile fa-stack-1x fa-inverse"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c704b5d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/document.vue
// module id = 277
// module chunks = 1